/**
 * @typedef { import('../../../time.js').YearMonth } YearMonth
 * @typedef { import('./report.js').Report } Report
 * @typedef { import('./report.js').Cohort } Cohort
 */

/**
 * @param {Report} report
 * @returns {string}
 */
export function convertReportToTableString(report) {

  const period = report.getPeriod();

  const beginMonth = period.getBegin();
  const endMonth   = period.getEnd();

  const metricStrings = [];
  for(let month = beginMonth; month.isBefore(endMonth); month = month.getNext()) {
    const cohort = report.getCohort(month);
    const cohortMetricStrings = convertCohortMetricsToStrings(cohort, month, endMonth);
    metricStrings.push(...cohortMetricStrings);
  }

  const title = 'cohort,size,pay_month,revenue';
  const dataStr = metricStrings.join("\n");
  const str = title + "\n" + dataStr + "\n";
  return str;
}

/**
 * @param {Cohort} cohort
 * @param {YearMonth} beginMonth
 * @param {YearMonth} endMonth
 * @returns {string[]}
 */
function convertCohortMetricsToStrings(cohort, beginMonth, endMonth) {
  /** @type {string[]} */
  const strings = [];

  for(let month = beginMonth; month.isBefore(endMonth); month = month.getNext()) {
    const str = convertCohortMetricToString(cohort, month);
    strings.push(str);
  }

  return strings;
}
  
/**
 * @param {Cohort} cohort 
 * @param {YearMonth} month 
 * @returns {string}
 */
function convertCohortMetricToString(cohort, month) {
  const value = cohort.getMetric(month);

  const parts = [
    cohort.getName(),
    cohort.getSize(),
    month.toString(),
    value,
  ];

  return parts.join(',');
}
